var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('h4', [_vm._v("訂單管理")]), _c('div', {
    staticClass: "row mx-0 justify-content-between mb-2 mt-3"
  }, [_c('div', [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ['collapse-filter', 'collapse-search'],
      expression: "['collapse-filter', 'collapse-search']"
    }],
    attrs: {
      "variant": "outline-info"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-magnify"
  }), _vm._v("進階搜尋 ")])], 1), _vm.showFilter ? _c('div', [_vm.$permissions.has(_vm.$permissions.consts.ORDER_TO_POINT_CALCULATE) ? _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "inverse-info",
      "disabled": _vm.isConvertingOrderToPoints
    },
    on: {
      "click": _vm.handleOrderToPointCalculateButtonClicked
    }
  }, [_vm.isConvertingOrderToPoints ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _c('span', {
    staticClass: "mdi mdi-cloud-upload mr-1"
  }), _vm._v("訂單給點即時運算 ")], 1) : _vm._e(), _vm.$permissions.hasAny([_vm.$permissions.consts.ORDER_IMPORT_LIGHT, _vm.$permissions.consts.ORDER_IMPORT]) ? _c('span', {
    staticClass: "mr-2"
  }, [_c('b-button', {
    attrs: {
      "variant": "inverse-info",
      "to": {
        name: 'OrderImport',
        query: {
          merchant_id: this.query.merchant_id
        }
      },
      "disabled": _vm.query.merchant_id === null || _vm.query.merchant_id === 'null'
    }
  }, [_c('span', {
    staticClass: "mdi mdi-cloud-upload mr-1"
  }), _vm._v("批次上傳 ")])], 1) : _vm._e(), _c('b-dropdown', {
    staticClass: "mr-2",
    attrs: {
      "text": "匯出",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": _vm.listExport
    }
  }, [_vm._v("清單匯出")]), _c('b-dropdown-item', {
    on: {
      "click": _vm.detailExport
    }
  }, [_vm._v("明細匯出")])], 1), _vm.$permissions.has(_vm.$permissions.consts.ORDER_CREATE) ? _c('b-dropdown', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.query.merchant_id === null || _vm.query.merchant_id === 'null'
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fa fa-plus",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("新增訂單 ")];
      },
      proxy: true
    }], null, false, 3330248580)
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'OrderCreate',
        query: {
          merchant_id: _vm.query.merchant_id,
          simplified: 1
        }
      }
    }
  }, [_vm._v("新增訂單-精簡")]), _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'OrderCreate',
        query: {
          merchant_id: _vm.query.merchant_id
        }
      }
    }
  }, [_vm._v("新增訂單-標準")])], 1) : _vm._e()], 1) : _vm._e()]), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-filter"
    }
  }, [_c('b-card', [_c('b-form', {
    attrs: {
      "inline": ""
    }
  }, [!_vm.showFilter ? _c('b-form-group', {
    staticClass: "mr-2 mb-2",
    attrs: {
      "label": "通路名稱"
    }
  }, [!_vm.showFilter ? _c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.merchants.length == 2
    },
    on: {
      "change": _vm.handleMerchantIdChange
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.showFilter ? _c('b-form-group', {
    staticClass: "mr-2 mb-2",
    attrs: {
      "label": "通路名稱"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.merchants.length == 2
    },
    on: {
      "change": _vm.handleMerchantIdChange
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm.showFilter ? _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-search"
    }
  }, [_c('b-card', [_c('b-input-group', [_c('b-form-input', {
    staticStyle: {
      "max-width": "500px"
    },
    attrs: {
      "placeholder": "訂單編號或外部編號"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)], 1) : _vm._e(), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.orders,
      "fields": _vm.filteredFields
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "cell(branch)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.branch ? data.item.branch.name / data.item.branch.id : "") + " ")];
      }
    }, {
      key: "cell(order_number)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'OrderDetail',
              params: {
                order_id: data.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.order_number) + " ")])];
      }
    }, {
      key: "cell(outer_order_number)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'OrderDetail',
              params: {
                order_id: data.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.outer_order_number) + " ")])];
      }
    }, {
      key: "cell(customer_name)",
      fn: function fn(data) {
        return [data.item.customer ? _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('router-link', {
          staticClass: "mr-1",
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.customer.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.customer.name) + " ")]), _c('span', {
          staticClass: "mdi mdi-account-search",
          staticStyle: {
            "cursor": "pointer",
            "font-size": "1.2rem",
            "color": "#007bff",
            "line-height": "1"
          },
          attrs: {
            "id": "popover-customer-".concat(data.item.id)
          },
          on: {
            "click": function click($event) {
              return _vm.openCustomerInfoModal(data.item.customer);
            }
          }
        }), _c('b-popover', {
          attrs: {
            "target": "popover-customer-".concat(data.item.id),
            "triggers": "hover focus"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v("點擊，檢視會員資料及綁定狀況")])])], 1) : _c('span', [_vm._v("-")])];
      }
    }, {
      key: "cell(memo)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex flex-column align-items-center"
        }, [data.item.memo ? _c('span', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-memo-view",
            modifiers: {
              "modal-memo-view": true
            }
          }],
          staticClass: "mdi mdi-tag-text-outline mr-1",
          staticStyle: {
            "cursor": "pointer",
            "font-size": "1rem"
          },
          attrs: {
            "id": "popover-memo-".concat(data.item.id)
          },
          on: {
            "click": function click($event) {
              _vm.modalTitle = '消費備註', _vm.modalContent = data.item.memo;
            }
          }
        }) : _vm._e(), data.item.memo ? _c('b-popover', {
          attrs: {
            "target": "popover-memo-".concat(data.item.id),
            "triggers": "hover focus"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v("點擊，觀看『消費備註』")])]) : _vm._e(), data.item.processed_memo ? _c('span', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-memo-view",
            modifiers: {
              "modal-memo-view": true
            }
          }],
          staticClass: "mdi mdi-coin",
          staticStyle: {
            "cursor": "pointer",
            "font-size": "1rem"
          },
          attrs: {
            "id": "popover-points-".concat(data.item.id)
          },
          on: {
            "click": function click($event) {
              _vm.modalTitle = '入點說明', _vm.modalContent = data.item.processed_memo;
            }
          }
        }) : _vm._e(), data.item.processed_memo ? _c('b-popover', {
          attrs: {
            "target": "popover-points-".concat(data.item.id),
            "triggers": "hover focus"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v("點擊，觀看『入點說明』")])]) : _vm._e()], 1)];
      }
    }, {
      key: "cell(action)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.ORDER_ASSIGN_CUSTOMER]) && !_vm.upperCustomerId || _vm.checkPermission([_vm.consts.ORDER_POINT_DELETE]) ? _c('b-dropdown', {
          staticClass: "ml-2",
          attrs: {
            "size": "sm",
            "variant": "inverse-secondary"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "mdi mdi-menu"
        })]), _vm.checkPermission([_vm.consts.ORDER_ASSIGN_CUSTOMER]) && !_vm.upperCustomerId ? _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.openAssignCustomerModal(data.item);
            }
          }
        }, [_vm._v(" 訂單歸戶 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.ORDER_POINT_DELETE]) ? _c('span', {
          attrs: {
            "id": "delete-points-tooltip-".concat(data.item.id)
          }
        }, [_c('b-dropdown-item', {
          attrs: {
            "disabled": !data.item.reward_points_earned_customer_id
          },
          on: {
            "click": function click($event) {
              return _vm.handleDeleteOrderPoints(data.item);
            }
          }
        }, [_vm._v(" 刪除點數紀錄 ")])], 1) : _vm._e(), _vm.checkPermission([_vm.consts.ORDER_POINT_DELETE]) && !data.item.reward_points_earned_customer_id ? _c('b-tooltip', {
          attrs: {
            "target": "delete-points-tooltip-".concat(data.item.id),
            "triggers": "hover"
          }
        }, [_vm._v(" 此訂單沒有入點會員資料 ")]) : _vm._e()], 2) : _vm._e(), _vm.checkPermission([_vm.consts.ORDER_LIST_VIEW]) && !_vm.upperCustomerId ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'OrderDetail',
              params: {
                order_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye mr-1"
        }), _vm._v("查看 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.ORDER_MODIFY]) && !_vm.upperCustomerId ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'OrderEdit',
              params: {
                order_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil mr-1"
        }), _vm._v("編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.ORDER_DELETE]) && !_vm.upperCustomerId ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(data.item.id);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete mr-1"
        }), _vm._v("刪除 ")]) : _vm._e()];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  }), _c('b-modal', {
    attrs: {
      "id": "modal-upload",
      "title": "批次上傳-標準"
    },
    on: {
      "hidden": _vm.resetUploadModal
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "variant": "secondary",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")]), _c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "variant": "primary",
            "size": "sm",
            "disabled": !_vm.uploadFileComplex || _vm.showLoadingUpload
          },
          on: {
            "click": _vm.uploadOrderWithComplexSchema
          }
        }, [_vm.showLoadingUpload ? _c('b-spinner', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" 送出 ")], 1)];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("選擇通路")]), _c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": ""
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("請上傳 Excel 檔案")]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    model: {
      value: _vm.uploadFileComplex,
      callback: function callback($$v) {
        _vm.uploadFileComplex = $$v;
      },
      expression: "uploadFileComplex"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.autoGenerateMember,
      callback: function callback($$v) {
        _vm.autoGenerateMember = $$v;
      },
      expression: "autoGenerateMember"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("自動建立會員編號")])])], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.getSampleExcelFile(_vm.getModuleConfig('order', 'sample_file.order_import_xls'), '/excel/order_standard_list.xlsx');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("下載範例檔案")])], 1)])], 1), _c('b-modal', {
    attrs: {
      "id": "modal-upload-simplified",
      "title": "批次上傳-精簡"
    },
    on: {
      "hidden": _vm.resetUploadModal
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var cancel = _ref2.cancel;
        return [_c('b-button', {
          attrs: {
            "variant": "secondary",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")]), _c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "variant": "primary",
            "size": "sm",
            "disabled": !_vm.uploadFileSimplified || _vm.showLoadingUpload
          },
          on: {
            "click": _vm.uploadOrderWithSimplifiedSchema
          }
        }, [_vm.showLoadingUpload ? _c('b-spinner', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" 送出 ")], 1)];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("選擇通路")]), _c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": ""
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("請上傳 Excel 檔案")]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    model: {
      value: _vm.uploadFileSimplified,
      callback: function callback($$v) {
        _vm.uploadFileSimplified = $$v;
      },
      expression: "uploadFileSimplified"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.autoGenerateMember,
      callback: function callback($$v) {
        _vm.autoGenerateMember = $$v;
      },
      expression: "autoGenerateMember"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("自動建立會員編號")])])], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.getSampleExcelFile(_vm.getModuleConfig('order', 'sample_file.order_import_light_xls'), '/excel/order_simple_list.xlsx');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("下載範例檔案")])], 1)])], 1), _c('StaffAddCustomer', {
    ref: "assignCustomerModal",
    attrs: {
      "show-btn": false,
      "can-select": false,
      "source-type": _vm.selectedOrder ? _vm.getOrderMerchantType(_vm.selectedOrder) : 'line',
      "title": "訂單歸戶"
    },
    on: {
      "bind": _vm.handleCustomerSelected
    }
  }), _c('b-modal', {
    attrs: {
      "id": "modal-memo-view",
      "title": _vm.modalTitle
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var cancel = _ref3.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "p-3",
    staticStyle: {
      "white-space": "pre-wrap",
      "max-height": "400px",
      "overflow-y": "auto"
    }
  }, [_vm._v(_vm._s(_vm.modalContent))])]), _c('b-modal', {
    attrs: {
      "id": "modal-customer-info",
      "size": "md"
    },
    on: {
      "hidden": _vm.resetCustomerModal
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "modal-title"
        }, [_vm.selectedCustomer ? _c('router-link', {
          staticClass: "hover-underline",
          staticStyle: {
            "text-decoration": "none"
          },
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: _vm.selectedCustomer.id
              }
            }
          }
        }, [_vm._v(" 會員資料 ")]) : _vm._e()], 1), _c('button', {
          staticClass: "close",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('modal-customer-info');
            }
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])];
      },
      proxy: true
    }, {
      key: "modal-footer",
      fn: function fn(_ref4) {
        var cancel = _ref4.cancel;
        return [_c('b-button', {
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingModal,
      "rounded": "sm"
    }
  }, [_vm.selectedCustomer ? _c('div', {
    staticClass: "p-3",
    staticStyle: {
      "max-height": "500px",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('CustomerInfoCard', {
    attrs: {
      "customer": _vm.selectedCustomer
    }
  })], 1), _vm.bindingCustomers.length > 0 ? _c('div', {
    staticClass: "mt-4"
  }, [_c('hr'), _c('h6', {
    staticClass: "mb-3"
  }, [_c('i', {
    staticClass: "mdi mdi-link-variant mr-2"
  }), _vm._v("綁定會員 ")]), _vm._l(_vm.bindingCustomers, function (customer) {
    return _c('div', {
      key: customer.id,
      staticClass: "mb-4"
    }, [_c('CustomerInfoCard', {
      attrs: {
        "customer": customer,
        "compact": true
      }
    })], 1);
  })], 2) : _vm._e()]) : _vm._e()])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }